<template>
  <div :class="$style.auth" :style="styleBg">
    <div class="pt-5 pb-5 d-flex align-items-end mt-auto">
      <div class="air__utils__logo__text">
        <img :src="logo" :alt="nomeSaleChannel" width="250px" />
      </div>
    </div>
    <div class="pl-5 pr-5 pt-5 pb-5 bg-white text-center" :class="$style.container">
      <div class="air__utils__logo__name text-uppercase text-dark font-size-21">
        Painel Administrativo
      </div>
      <div class="air__utils__logo__descr text-uppercase font-size-12 text-gray-6 mb-4">
        Forneça seus dados de acesso
      </div>
      <a-form class="mb-4" :form="form" @submit="login">
        <a-form-item>
          <a-input size="large" placeholder="CPF" v-decorator="[
            'cpf',
            {
              initialValue: '',
              rules: [
                { required: true, message: 'Por favor informe seu CPF' },
              ],
            },
          ]" />
        </a-form-item>
        <a-form-item class="mb-4">
          <a-input size="large" placeholder="Senha" type="password" v-decorator="[
            'password',
            {
              initialValue: '',
              rules: [
                { required: true, message: 'Por favor informe sua senha' },
              ],
            },
          ]" />
        </a-form-item>
        <a-button type="primary" htmlType="submit" size="large" :style="stylePrimary"
          class="text-center btn btn-primary w-100 font-weight-bold font-size-18">Entrar</a-button>
      </a-form>

      <router-link to="/system/forgot-password" class="text-info font-weight-bold font-size-18">Esqueceu sua
        senha?</router-link>
    </div>
    <div class="mt-auto pb-5 pt-5">
      <ul class="list-unstyled d-flex mb-2 flex-wrap justify-content-center" :class="$style.footerNav"></ul>
      <div class="logo-rodape">
        <a href="https://acquire.solutions" target="_blank" title="Acquire - Plataforma Para Gestão de Recebíveis!">
          <img src="resources/images/logo.png" alt="Acquire Solutions" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { UsuarioResource } from "@/resources/Usuario.resource.js";
import Jwt from "jsonwebtoken";
import { mapState, mapGetters } from "vuex";
import Vue from "vue";

const LOGO_BASE = "resources/images/logo.png";
const NOME_BASE = "Acquire Solutions";

export default {
  name: "AirLogin",
  data: function () {
    return {
      form: this.$form.createForm(this),
      erroPadrao: {
        message: "Erro",
        description:
          "Não foi possível realizar o login, por favor tente novamente mais tarde.",
      },
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
    ...mapGetters({
      getFrontEndVersion: "getFrontEndVersion",
      getConfig: "getConfig",
    }),
    logo() {
      try {
        return this.getConfig.logo || LOGO_BASE;
      } catch (e) {
        return LOGO_BASE;
      }
    },
    styleBg() {
      return "background-color: var(--primaryColor)";
    },
    stylePrimary() {
      try {
        return `background-color: ${this.getConfig.primaryColor} !important ; border-color:${this.getConfig.primaryColor}`;
      } catch (e) {
        return "";
      }
    },
    nomeSaleChannel() {
      try {
        return this.getConfig.name || NOME_BASE;
      } catch (e) {
        return NOME_BASE;
      }
    },
  },
  methods: {
    login(e) {
      e.preventDefault();
      const v = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$nprogress.start();
          UsuarioResource.autenticar({
            userName: values.cpf,
            password: values.password,
          })
            .then((response) => {
              if (response.data.isSuccess) {
                try {
                  // atualiza os dados...
                  const decodedToken = Jwt.decode(response.data.payload.token);

                  v.$store.commit("setUser", decodedToken);
                  v.$store.commit("setToken", response.data.payload.token);

                  v.$notification["success"]({
                    message: "Usuário Autenticado",
                    description: "Usuário autenticado com sucesso!",
                  });

                } catch (e) {
                  throw v.erroPadrao;
                }
              } else {
                throw v.erroPadrao;
              }
              this.$nprogress.done();
            })
            .catch((error) => {
              var warn = {
                message: "Não foi possível acessar o sistema",
                description: error.message,
              };

              if (error.response.data.failureReason) {
                warn.description = error.response.data.failureReason;
              }

              this.$nprogress.done();
              this.$notification["error"](warn);
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" module>
@import "@/components/system/Auth/style.module.scss";
</style>
